import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { useAuthStore } from './stores/auth'
import './assets/css/main.css'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

// Инициализация auth store (определение города по поддомену и восстановление сессии)
const authStore = useAuthStore()
authStore.init()

app.mount('#app')

